declare const Stripe;
import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { ProductDataProvider } from "../../data-provider/product.dp";
import { SubscriptionDataProvider } from "../../data-provider/subscription.dp";

let StripeCardFormComponent = {
    selector: "vcStripeCardForm",
    templateUrl:
        "/angular/components/campaign-plan/stripe-card-form.component.html",
    bindings: {
        plan: "=",
        close: "&",
        focus: "&?",
        charge: "=",
        signup: "=",
        creatingAccount: "=?",
        usedTrial: "=?",
    },
    controller: class StripeCardFormController {
        // * bindings for typescript compiler *
        public plan: any;
        public close: any;
        public charge: any;
        public signup: any;
        public creatingAccount?: any;
        public usedTrial?: any;
        public showPromo: boolean = false;
        // ************************************

        private campaign: Campaign;
        private promoCode: string = "";
        private promoExplainer: string = "";
        private promoErrors = [];
        private promoLoading: boolean = false;
        private error: string = "";
        private trialEndDate: string;
        private card: any;
        private currentYear: number;
        private setupIntentResult: any;
        private stripe: any;
        private cardNumber: any;
        private couponId: any;

        private $scope: any;
        private __env: any;

        private subscriptionDataProvider: SubscriptionDataProvider;
        private campaignDataProvider: CampaignDataProvider;
        private productDataProvider: ProductDataProvider;

        constructor(
            $scope: any,
            __env: any,
            SubscriptionDataProvider: SubscriptionDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            ProductDataProvider: ProductDataProvider
        ) {
            this.$scope = $scope;
            this.__env = __env;

            this.subscriptionDataProvider = SubscriptionDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.productDataProvider = ProductDataProvider;

            this.campaign = this.campaignDataProvider.getActiveCampaign();

            let trialEndDate = new Date();
            trialEndDate.setDate(
                trialEndDate.getDate() + parseInt(this.__env.trial_days)
            );
            this.trialEndDate =
                trialEndDate.getFullYear() +
                "-" +
                (trialEndDate.getMonth() + 1) +
                "-" +
                trialEndDate.getDate() +
                " " +
                trialEndDate.getHours() +
                ":" +
                trialEndDate.getMinutes() +
                ":" +
                trialEndDate.getSeconds();

            this.currentYear = parseInt(
                new Date().getFullYear().toString().substr(-2)
            );

            this.stripe = Stripe(this.__env.stripe_api_key);
            let elements = this.stripe.elements();

            let elementClasses = {
                focus: "focused",
                empty: "empty",
                invalid: "invalid",
            };

            this.cardNumber = elements.create("cardNumber", {
                style: {},
                classes: elementClasses,
            });
            this.cardNumber.mount("#example2-card-number");

            let cardExpiry = elements.create("cardExpiry", {
                style: {},
                classes: elementClasses,
            });
            cardExpiry.mount("#example2-card-expiry");

            let cardCvc = elements.create("cardCvc", {
                style: {},
                classes: elementClasses,
            });
            cardCvc.mount("#example2-card-cvc");
        }

        $onInit() {
            if (!angular.isDefined(this.plan)) this.plan = { loading: false };

            this.card = {
                brand: "unknown",
                holder_name: "",
                intent: this.plan.intent,
            };

            this.cardNumber.on("change", (event) => {
                this.card.brand = event.brand;
                this.$scope.$apply();
            });

            this.$scope.$on("focusPaymentDetails", () => {
                this.cardNumber.focus();
            });
        }

        confirm(card) {
            if (this.setupIntentResult) {
                //if payment details have already been added successfully. Don't retry to create the setup intent
                this.handleStripeResponse(
                    this.setupIntentResult,
                    this.setupIntentResult.setupIntent.payment_method
                );
            } else {
                this.plan.loading = true;
                this.creatingAccount.loading = true;
                this.card.created = false;
                this.error = "";

                if (this.charge == false) {
                    this.stripe
                        .handleCardSetup(this.plan.intent, this.cardNumber, {
                            payment_method_data: {
                                billing_details: {
                                    name: card.holder_name,
                                },
                            },
                        })
                        .then((result) => {
                            if (result.error) {
                                this.creatingAccount.loading = false;
                                this.handleStripeErrorResponse(result.error);
                            } else {
                                this.handleStripeResponse(
                                    result,
                                    result.setupIntent.payment_method
                                );
                            }
                        });
                } else {
                    this.stripe
                        .handleCardPayment(this.plan.intent, this.cardNumber, {
                            payment_method_data: {
                                billing_details: {
                                    name: card.holder_name,
                                },
                            },
                        })
                        .then((result) => {
                            if (result.error) {
                                this.creatingAccount.loading = false;
                                this.handleStripeErrorResponse(result.error);
                            } else {
                                this.handleStripeResponse(
                                    result,
                                    result.paymentIntent.payment_method
                                );
                            }
                        });
                }
            }
        }

        handleStripeResponse(result, payment_method) {
            this.setupIntentResult = _.cloneDeep(result);
            this.card.created = true;
            let promo = this.couponId ? this.promoCode : ""; //only send a promo code if it was successfully applied
            if (this.signup) {
                this.close({
                    card: this.card,
                    payment_method: payment_method,
                    promo_code: promo,
                });
            } else {
                this.subscriptionDataProvider
                    .paymentMethod(payment_method, false)
                    .then((data) => {
                        this.close({ card: this.card });
                    });
            }
        }

        handleStripeErrorResponse(error) {
            this.card.created = false;
            this.plan.loading = false;
            this.error = error.message;
            this.$scope.$apply();
        }

        checkPromoCode(code) {
            this.promoExplainer = "";
            this.promoErrors = [];
            this.promoLoading = true;
            this.couponId = null;
            this.subscriptionDataProvider.checkPromoCode(code).then(
                (result) => {
                    this.promoLoading = false;
                    this.promoExplainer =
                        this.productDataProvider.couponDescription(
                            result.coupon
                        );
                    this.couponId = result.coupon.id;
                },
                (data) => {
                    this.promoErrors = data.message;
                    this.promoLoading = false;
                }
            );
        }

        resetCode() {
            this.promoCode = "";
            this.promoExplainer = "";
            this.promoErrors = [];
            this.promoLoading = false;
            this.couponId = null;
        }
    },
};

angular
    .module("campaignplan")
    .component(StripeCardFormComponent.selector, StripeCardFormComponent);
